import { render } from "./LightBox.vue?vue&type=template&id=2d80984b"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"
script.render = render

export default script